var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Header')],1),_c('div',[_c('Middle')],1),_c('div',[_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }